module.exports = __webpack_public_path__ + "img/qtouch_small_detail.8fe1b585.png";